import axiosAuth from '../../axiosMain';

async function store(data) {
  let response = await axiosAuth.post('/auth_client', data);
  return response.data;
}

async function show(id) {
  let response = await axiosAuth.get('/auth_client/' + id);
  return response.data;
}

async function update(id, data) {
  let response = await axiosAuth.patch('/auth_client/' + id, data);
  return response.data;
}

async function destroy(id) {
  let response = await axiosAuth.delete('/auth_client/' + id);
  return response.data;
}

export default {
  store,
  show,
  update,
  destroy,
};
